const MOBILE_NUMBER_REGEXP_ONLY_DIGITS = /^\d+$/;
const DIGIT_REGEXP = /[0-9]+/g;

const isLengthExceeded = (value: string, lengthLimit?: number): boolean => {
  if (!lengthLimit) {
    return false;
  }

  const digitsMatch = value.match(DIGIT_REGEXP);
  const digitsLength = digitsMatch?.join('')?.length;

  const output = !!digitsLength && digitsLength > lengthLimit;
  return output;
};

export const isMobileNumberValid = (
  value: string | null,
  lengthLimit?: number
): boolean => {
  if (typeof value !== 'string') {
    return false;
  }

  if (!value) {
    return true;
  }

  const lengthExceeded = isLengthExceeded(value, lengthLimit);

  if (lengthExceeded) {
    return false;
  }

  const isValid = MOBILE_NUMBER_REGEXP_ONLY_DIGITS.test(value);
  return isValid;
};
